import React from 'react';

export default class  Page7 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToRaiseEnergyLevels');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="paraspace"><p>Doing the following will increase your
                                                chances of a positive dream:</p></div>
                                            <p><span className="brown boldtext numeric">1.</span>Give the
                                                positive event a name, e.g. ‘my sister’s baby’.</p>
                                            <p><span className="brown boldtext numeric">2.</span>Visualise it.
                                            </p>
                                            <p><span className="brown boldtext numeric">3.</span> <span
                                                style={{float:'left',width:'95%'}}>As you go to sleep, say the name over and over, visualise it and intend to dream about it.</span>
                                            </p><br/>
                                            <p>Be prepared to practise – it may take several attempts before you
                                                manage to influence your dreams (it works about 25% of the
                                                time).</p>
                                            <div className="border_subtitle">Then...</div>
                                            <p>Continue to take stock of good events in your life, even if you
                                                stop writing them down – it’s always good to end the day
                                                thinking about something positive!</p>

                                            <div className="circle_title"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>SUMMARY</div>
                                            <p>Raising your energy levels can be a profoundly exhilarating
                                                experience. Be prepared to put in the effort yourself and you’re
                                                likely to find it’s ‘catching’ and affects others around
                                                you!</p>

                                            <div className="circle_title"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>Further Information</div>
                                            <div className="paraspace"><p>If you found this tool useful then you
                                                are likely to find the following tools both insightful and
                                                relevant:</p></div>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list">
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToMotivateOthers')}>How
                                                        to motivate others</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToMaintainMomentum')}>How
                                                        to maintain momentum</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToCopeWithSetbacks')}>How
                                                        to cope with setbacks</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToBuildResilience')}>How
                                                        to build resilience</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToGetTheMostOutOfYourself')}>How
                                                        to get the most out of yourself.</div></li>
                                                </ul>
                                            </div>

                                            <div className="circle_title"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>REFERENCES</div>
                                            <ol className="testclass">
                                                <li><p className="further_info_content">Puri,
                                                    M., &amp; Robinson, D. T. (2007). Optimism and economic
                                                    choice.<span className="subtiltereg"> Journal of Financial Economics</span>,
                                                    86(1), 71-99.</p></li>
                                                <li><p className="further_info_content">Herzberg, F.
                                                    (1966). <span className="subtiltereg">Work and the Nature of Man.</span> Cleveland:
                                                    World Publishing Co.</p></li>
                                                <li><p className="further_info_content">Moore, P. (2012). <span
                                                    className="subtiltereg">The Posture Doctor: The Art and Science of Healthy Posture.</span> Ecademy
                                                    Press Limited.</p></li>
                                                <li><p className="further_info_content">Lewis, M.
                                                    B., &amp; Bowler, P. J. (2009). Botulinum toxin cosmetic
                                                    therapy correlates with a more positive mood.<span
                                                        className="subtiltereg"> Journal of cosmetic dermatology</span>,
                                                    8(1), 24-26.</p></li>
                                                <li><p className="further_info_content">Kavouras, S. (2002).
                                                    Assessing hydration status. <span className="subtiltereg">Current opinion in clinical nutrition and metabolic care</span>,
                                                    5(5), 515-524.</p></li>
                                                <li><p className="further_info_content">Sheedy, J. (2005).<span
                                                    className="subtiltereg"> Optometry and Vision Science</span>,
                                                    82, 905-911.</p></li>
                                                <li><p className="further_info_content"><a
                                                    href="https://www.nlm.nih.gov/medlineplus/exerciseandphysicalfitness.html"
                                                    target="_blank"
                                                    className="link_color people">www.nlm.nih.gov/medlineplus/exerciseandphysicalfitness.html</a>
                                                </p></li>
                                                <li><p className="further_info_content"><a
                                                    href="http://www.cioupdate.com/career/article.php/3515456/Re-Energizing-Your-Workforce.htm"
                                                    target="_blank"
                                                    className="link_color people">www.cioupdate.com/career/article.php/3515456.</a>
                                                </p></li>
                                                <li><p className="further_info_content">Greenwich, C.
                                                    (2000). <span className="subtiltereg">Energiser of the week: Fun and Gains.</span> McGraw-Hill
                                                    Book Co.</p></li>
                                                <li><p className="further_info_content">Seligman, M.
                                                    (2004). <span className="subtiltereg">Authentic Happiness: Using the New Positive Psychology to Realize Your Potential for Lasting Fulfillment.</span> The
                                                    Free Press.</p></li>
                                            </ol>

                                            <div className="left-btn"><div
                                                onClick={this.props.handleChangePage('Page6')}
                                                className="button-next-previous-done">&lt;&lt; Previous </div></div>
                                            <div className="right-btn"><div
                                                onClick={this._savePageStatus('People')}
                                                className="button-next-previous-done">Done</div></div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}